import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import CudaPaper from 'common/components/CudaPaper'
import Grid from '@material-ui/core/Grid'
import { TableHead, TableBody, Table, TableRow, TableCell } from '@material-ui/core';
import { CudaInfoTooltip } from 'common/components/CudaTooltip'
import Paginator from 'common/components/Paginator';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';


const styles = {
    titleContainer: {
        padding: '20px'
    },
    titleText: {
        color: 'rgba(0,0,0,0.9)',
        fontSize: '24px',
        fontWeight: 300,
        lineHeight: '28px'
    },
    titleIcon: {
        width: '30px',
        height: '26px'
    },
    tableHelpIcon: {

    }
}

const ExpiredApps = ({ classes, accounts = [], page, itemsTotal, itemsPerPage, changeitemsPerPage, pageChange }) => {
    return <CudaPaper>
        <Grid container>
            <Grid container item xs={12} className={classes.titleContainer} spacing={1}>
                <Grid item>
                    <ReportProblemIcon color='primary' className={classes.titleIcon} />
                </Grid>
                <Grid item className={classes.titleText}>
                    Problematic Accounts
                </Grid>
            </Grid>
            <Grid container item xs={12}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                Account Name
                            </TableCell>
                            <TableCell>
                                Trial
                            </TableCell>
                            <TableCell>
                                <Grid container alignItems='center'>
                                    Last Login Time
                                    <CudaInfoTooltip title='Last time anyone (who is not Barracuda Support) logged in to the account' />
                                </Grid>
                            </TableCell>
                            <TableCell>
                                <Grid container alignItems='center'>
                                    Last User
                                    <CudaInfoTooltip title='Last user (who is not Barracuda Support) who logged in to the account' />
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            accounts.map(account => <TableRow>
                                <TableCell>
                                    {account.id} -
                                                                        {account.name}
                                </TableCell>
                                <TableCell>
                                    {account.trial ? 'YES' : 'NO'}
                                </TableCell>
                                <TableCell>
                                    {
                                        account.last_login
                                    }
                                </TableCell>
                                <TableCell>
                                    {account.last_user}({account.last_username})
                                                                    </TableCell>
                            </TableRow>)
                        }

                    </TableBody>
                </Table>
            </Grid>
            <Grid container item xs={12}>
                <Paginator
                    pageNumber={page}
                    itemsTotal={itemsTotal}
                    countSelector={true}
                    changeitemsPerPage={(event) => { changeitemsPerPage(event.target.value) }}
                    itemsPerPage={itemsPerPage}
                    onNextClick={() => pageChange(1)}
                    onPreviousClick={() => pageChange(-1)}
                />
            </Grid>
        </Grid>
    </CudaPaper>
}

export default withStyles(styles)(ExpiredApps)